import { createGlobalStyle } from "styled-components";
export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: Tahoma, Helvetica, Arial, Roboto, sans-serif;
    transition: all 0.50s linear;
  }
  h1,h2 {
    color: ${({ theme }) => theme.text} !important;
  }
  .menuIcon {
    background: ${({ theme }) => (theme.body === "#121212" ? "#f0f0f0" : "#121212")};
  }
  .sidebar {
    background: ${({ theme }) => (theme.body === "#121212" ? theme.body : "#fff")};
  }
  .menuItem,.modal-wrapper {
    background: ${({ theme }) => theme.body} !important;
  }
  .grid-gallery-cell,.carousel-image,.masonry-image-container,video {
    filter: ${({ theme }) => (theme.body === "#121212" ? "brightness(0.8) contrast(1.2)" : "none")};
  }
  .wb-body {
    background: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  `;
